import React, { useContext, useEffect, useRef } from 'react';
import { LiliTransaction } from '../../types/lili-transaction';
import { FlowContext } from '../TransactionsWrapper';
import { ETransactionsState } from '../../hooks/useTransactionsData';

export const PagingTrigger = (transaction: LiliTransaction) => {
  const elWrapper = useRef<HTMLDivElement>(null);
  const { isLast } = transaction;
  const ctx = useContext(FlowContext);
  const { transactionId } = transaction;

  useEffect(() => {
    if (elWrapper.current && isLast && ctx.dataState !== ETransactionsState.Loading) {
      const observer = new IntersectionObserver(
        (entries, os) => {
          if (entries[entries.length - 1].isIntersecting) {
            if (isLast) {
              ctx.loadMore();
            }
            os.disconnect();
          }
        },
        { rootMargin: '0px', threshold: 0 },
      );
      observer.observe(elWrapper.current);
    }
  }, [elWrapper, isLast]);

  return <div id={transactionId} ref={elWrapper} className='opacity-0 px-[10px] py-[10px]' />;
};
